import { ReactIcons } from "@kalyzee/escaet-ui";
import { MeetingOrderedSession } from "@kalyzee/kast-web-sdk";
import { MeetingSession } from "@kalyzee/kast-web-sdk/websocket";
import { useAlerts } from "../../hooks/meeting";

export interface BadBehaviorsIndicatorProps {
  session: MeetingSession | MeetingOrderedSession;
  style?: React.CSSProperties;
}

export const BadBehaviorsIndicator: React.FC<BadBehaviorsIndicatorProps> = ({
  session,
  style,
}) => {
  const alerts = useAlerts(session);

  const renderIcon = (
    Icon: React.FC<React.SVGProps<SVGSVGElement>>,
  ) => (
    <div style={{
      backgroundColor: "#7C7C7C",
      borderRadius: "50%",
      height: "2em",
      width: "2em",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}>
      <Icon style={{ width: "1em", height: "1em", color: "white" }} />
    </div>
  );


  if (!alerts.camera && !alerts.attention) {
    return null
  }

  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      gap: "0.5em",
      ...(style ?? {}),
    }}>
      {alerts.camera && renderIcon(ReactIcons.ApprenantUnion)}
      {alerts.attention && renderIcon(ReactIcons.ApprenantWarning)}
    </div>
  );
};